import Cart from "@components/shop/cart/component";

export default Cart;
